module.exports = __webpack_public_path__ + "static/media/PersonUsuaryImg.28bfc778.svg";